export const MODERATED_OPTIONS = [
    { value: null, name: "Не выбрано" },
    { value: 1, name: "Промодерировано" },
    { value: 0, name: "Не промодерировано" },
]
